export default {
  apiUrl: 'https://apidev.guestyforhosts.com',
  applicationHost: 'https://app-staging1.guestyforhosts.com',
  dioBaseUrl: 'https://app-staging16.guesty.com/api',
  googleClientId: '535440425652-k9m6jkff24vselntnv0icv96uo3a9vin.apps.googleusercontent.com',
};
